/*
 * Экраны контура входа: 1-Э1.1 и 4-А1.
 *
 * Контрольная ширина — 360: первый вечер владельца проходит с телефона, и это не
 * «адаптив десктопа», а основная раскладка экрана. Отсюда высота полей 48 px и размер
 * шрифта ввода 16 px: меньший размер Safari на iPhone встречает принудительным
 * приближением страницы, и форма уезжает из-под пальца на первом же касании.
 *
 * Ни одного цвета и ни одного размера мимо токенов.
 */

/*
 * ВЫСОТА СЧИТАЕТСЯ ОТ ЭКРАНА, А НЕ ОТ РОДИТЕЛЯ. `min-height: 100%` наследуется по цепочке
 * и у корня приложения превращается в auto: форма прижималась к верхнему краю, а под ней
 * оставалось пустое поле в треть экрана. `dvh` вместо `vh` — из-за адресной строки
 * мобильного браузера: на iPhone она съедает высоту и возвращает её при прокрутке,
 * и на `vh` подвал карточки уезжал под строку браузера.
 */
.page {
  display: flex;
  /* Телефон: карточка занимает экран целиком — подвал прижимается к низу, как в макете. */
  align-items: stretch;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: var(--space-6) var(--space-4);
  background: var(--bg-workspace);
}

.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 360px;
}

.langRow {
  display: flex;
  justify-content: flex-end;
  padding: var(--space-2) 0;
}

/* Выключенный переключатель языка виден и объяснён (см. login-screen.tsx). */
.lang[aria-disabled="true"] {
  cursor: default;
  opacity: 0.6;
}

.lang {
  padding: 5px 12px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  cursor: pointer;
  background: none;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
}

.brand {
  margin-top: 36px;
  font-size: 30px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  letter-spacing: 0.01em;
}

.brandSub {
  margin-bottom: 22px;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

/*
 * Плашка плановых работ. Тёмная и НАД полями: она отвечает на вопрос, который человек
 * задаёт себе первым — «я забыл пароль или у вас сломалось». Под кнопкой этот ответ
 * приходил бы после третьей попытки.
 */
.maintenance {
  padding: 14px;
  margin-bottom: 14px;
  font-size: var(--font-size-base);
  line-height: 1.5;
  color: var(--stripe-offline-fg);
  background: var(--stripe-offline-bg);
  border-radius: var(--radius-lg);
}

.field {
  margin-bottom: var(--space-3);
}

/* Поле ввода в форме входа — 48 px и 16 px шрифта: см. заголовок файла. */
.field input {
  height: var(--touch-min-target);
  font-size: 16px;
}

.phoneField input {
  font-variant-numeric: tabular-nums;
}

.invalid input {
  border-color: var(--danger);
  box-shadow: var(--field-invalid-ring);
}

/*
 * «Показать» СТОИТ ВРОВЕНЬ С ПОЛЕМ, и это не мелочь оформления.
 *
 * Было: у поля свой нижний отступ (.field), а выравнивание по нижнему краю считает
 * МАРГИН-БОКС — кнопка уезжала на 12 px ниже поля. Два элемента одной строки, стоящие
 * на разной высоте, человек читает как поломку раньше, чем успевает прочитать подпись.
 * Отступ переехал на сам ряд, поле внутри ряда его больше не несёт.
 */
.passwordRow {
  display: flex;
  gap: var(--space-2);
  align-items: flex-end;
  margin-bottom: var(--space-3);
}

.passwordRow > *:first-child {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}

.passwordRow button {
  flex: none;
  height: var(--touch-min-target);
}

/* Ошибка формы — ОДНА на всю форму, а не под каждым полем: сервер отвечает одним
   кодом на «нет адреса», «не тот пароль» и «учётка закрыта», и делать вид, что
   кабинет знает, какое из полей виновато, нельзя. */
.error {
  margin: -4px 0 var(--space-3);
  font-size: var(--font-size-md);
  line-height: 1.45;
  color: var(--status-no-show-fg);
}

.submit {
  height: var(--touch-min-target);
  font-size: var(--font-size-base);
  border-radius: 12px;
}

/*
 * Ряд ссылок под кнопкой. Высота строки 44 px — не ради воздуха: это способ входа
 * для того, кто пароль уже не помнит, и промахнуться по нему пальцем нельзя.
 */
.altActions {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: flex-start;
  margin-top: 18px;
}

.altAction {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
}

.altAction[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.45;
}

.foot {
  padding: var(--space-4) 0 22px;
  margin-top: auto;
  font-size: var(--font-size-sm);
  line-height: 1.5;
  color: var(--text-secondary);
}

.footLink {
  padding: 0;
  font-size: inherit;
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  cursor: pointer;
  background: none;
  border: 0;
}

/* Сообщение о прерванной сессии: не отказ формы, а причина, по которой человек здесь. */
.stolen {
  padding: 10px 12px;
  margin-bottom: var(--space-3);
  font-size: var(--font-size-md);
  line-height: 1.45;
  color: var(--status-no-show-fg);
  background: var(--status-no-show-bg);
  border: 1px solid var(--danger);
  border-radius: var(--radius-md);
}

.stolenTitle {
  font-weight: var(--font-weight-semibold);
}

/*
 * ШИРЕ ТЕЛЕФОНА — КАРТОЧКА. Макет 1-Э1.1 нарисован в рамке телефона 360×760, и рамка
 * там и есть карточка: фон, граница, скругление. На ноутбуке этой рамки нет, и форма
 * висела посреди пустого поля без единой границы — рядом с экраном второго фактора,
 * у которого карточка есть (screens/auth.module.css), вход выглядел недоделанным.
 *
 * Граница ровно в 768 px — там же, где её проводит вся остальная оболочка
 * (shell/layout.ts, PHONE_MAX_WIDTH): второй ширины в кабинете быть не должно.
 */
@media (min-width: 768px) {
  .page {
    /* Центрируем автоматическими полями: карточка выше экрана не должна обрезаться
       сверху (та же причина, что в screens/auth.module.css). */
    align-items: flex-start;
  }

  .card {
    margin: auto;
    padding: var(--space-4) var(--space-5) var(--space-5);
    background: var(--bg-card);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-pop);
  }

  /* Внутри карточки прижимать подвал к низу нечего: высота идёт по содержимому. */
  .foot {
    padding-bottom: 0;
    margin-top: var(--space-5);
  }

  .brand {
    margin-top: var(--space-4);
  }
}

/* ─────────── восстановление доступа (1-Э1.3) ─────────── */

/*
 * Экран запроса и экран нового пароля стоят на том же каркасе, что и вход: человек
 * попадает сюда с формы входа, и смена оформления посреди пути читается как «я не туда
 * попал». Поэтому здесь только то, чего на входе нет.
 */
.screen {
  display: flex;
  /* Автоматические поля у карточки вместо align-items: center — см. .page выше. */
  align-items: flex-start;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: var(--space-4);
  background: var(--bg-workspace);
}

.title {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.text {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-md);
  line-height: 1.45;
}

.hint {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-sm);
  line-height: 1.4;
  color: var(--text-secondary);
}

.failure {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-sm);
  color: var(--danger);
}

/* «‹ Вернуться ко входу» — первая строка карточки: выход всегда на виду. */
.screen > * {
  margin: auto;
}

.backLink {
  align-self: flex-start;
  margin-bottom: var(--space-2);
  padding: 0;
  font: inherit;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  cursor: pointer;
  background: none;
  border: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: var(--space-3);
}

/* Требования к паролю — ДО поля ввода, отмечаются по мере набора. */
.rules {
  margin: 0 0 var(--space-3);
  padding: 0;
  font-size: var(--font-size-sm);
  line-height: 1.5;
  color: var(--text-secondary);
  list-style: none;
}

.rule {
  color: var(--text-secondary);
}

.ruleMet {
  color: var(--status-in-progress-fg);
}

/* Два последствия смены пароля: их читают до того, как обнаружат сами. */
.consequences {
  margin: 0 0 var(--space-2);
  padding-left: var(--space-4);
  font-size: var(--font-size-md);
  line-height: 1.45;
}
